export const typographyConstants = {
  htmlFontSize: 16,
  fontFamily: "'Inter', sans-serif",
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 600,
  large_heading_38: {
    fontSize: '38px',
    fontWeight: 600,
    lineHeight: 1.21,
  },
  large_heading_30_regular: {
    fontSize: '30px',
    fontWeight: 400,
    lineHeight: 1.27,
  },
  large_heading_30_semibold: {
    fontSize: '30px',
    fontWeight: 600,
    lineHeight: 1.27,
  },
  heading_24_regular: {
    fontSize: '24px',
    fontWeight: 400,
    lineHeight: 1.33,
  },
  heading_24_semibold: {
    fontSize: '24px',
    fontWeight: 600,
    lineHeight: 1.33,
  },
  heading_20_medium: {
    fontSize: '20px',
    fontWeight: 500,
    lineHeight: 1.4,
  },
  heading_20_semibold: {
    fontSize: '20px',
    fontWeight: 600,
    lineHeight: 1.4,
  },
  subheading_16_regular: {
    fontSize: '16px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  subheading_16_medium: {
    fontSize: '16px',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  subheading_16_semibold: {
    fontSize: '16px',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  body_14_light: {
    fontSize: '14px',
    fontWeight: 300,
    lineHeight: 1.43,
  },
  body_14_regular: {
    fontSize: '14px',
    fontWeight: 400,
    lineHeight: 1.43,
  },
  body_14_medium: {
    fontSize: '14px',
    fontWeight: 500,
    lineHeight: 1.43,
  },
  body_14_semibold: {
    fontSize: '14px',
    fontWeight: 600,
    lineHeight: 1.43,
  },
  body_14_bold: {
    fontSize: '14px',
    fontWeight: 700,
    lineHeight: 1.43,
  },
  body_12_light: {
    fontSize: '12px',
    fontWeight: 300,
    lineHeight: 1.5,
  },
  body_12_regular: {
    fontSize: '12px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body_12_medium: {
    fontSize: '12px',
    fontWeight: 500,
    lineHeight: 1.5,
  },
  body_12_semibold: {
    fontSize: '12px',
    fontWeight: 600,
    lineHeight: 1.5,
  },
  body_12_bold: {
    fontSize: '12px',
    fontWeight: 700,
    lineHeight: 1.5,
  },
  body_10_regular_uppercase: {
    fontSize: '10px',
    fontWeight: 400,
    lineHeight: 1.6,
    textTransform: 'uppercase',
  },
  body_10_medium: {
    fontSize: '10px',
    fontWeight: 500,
    lineHeight: 1.6,
  },
  body_8_regular: {
    fontSize: '8px',
    fontWeight: 400,
    lineHeight: 1.5,
  },
  body_8_medium: {
    fontSize: '8px',
    fontWeight: 500,
    lineHeight: 1.5,
  },
};
